import { observable } from "mobx";
import { Type } from "class-transformer";
import ReportStatus from "./reportStatus";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class SubLedgerReportResponse {
  id!: string;

  @observable
  @Type(() => Date)
  createdAt!: Date;

  @observable
  createdBy!: string;

  @observable
  @Type(() => Date)
  lastDownloadedAt?: Date;

  @observable
  lastDownloadedBy?: string;

  @observable
  status!: ReportStatus;

  @observable
  reportDisplayName!: string;
}
